import z from "zod";

export const PredictionInputErrorItemSchema = z.object({
  code: z.enum(["missing", "value_error", "unknown_error"]),
  path: z.array(z.string()),
  message: z.string(),
});

const PredictionInputErrorSchema = z.object({
  errors: z.array(PredictionInputErrorItemSchema),
});

export type InvalidFields = Set<string>;

export function extractInvalidFieldsFromMetadata(errorMetadata: unknown): InvalidFields {
  if (!Array.isArray(errorMetadata)) {
    return new Set();
  }
  const fields = new Set<string>();
  const parsedMetadata = PredictionInputErrorSchema.safeParse({ errors: errorMetadata });

  if (!parsedMetadata.success) {
    return fields;
  }

  for (const error of parsedMetadata.data.errors) {
    if (!Array.isArray(error.path)) {
      continue;
    }
    for (const field of error.path) {
      fields.add(field);
    }
  }
  return fields;
}

export function isDimensionInvalid(
  fieldName: string,
  value: number | undefined,
  invalidFields: InvalidFields,
): boolean {
  if (invalidFields.has(fieldName)) {
    return true;
  }
  if (invalidFields.has("volume") && (!value || value <= 0)) {
    return true;
  }
  return false;
}

export const hasInvalidInputError = (errorMetadata: unknown): boolean => {
  const invalidFields = extractInvalidFieldsFromMetadata(errorMetadata);
  return invalidFields.size > 0;
};
